<git-task-commit *ngIf="(taskGitCommits$ | async).length > 0 && (isInstalled$ | async)"
  [taskCommits]="taskGitCommits$ | async"
  (removeCommit)="onRemove($event)"
>
<git-task-block-title [integrationName]="name"  [title]="'Bitbucket Commits'"></git-task-block-title>
</git-task-commit>
